<template>
  <div id="device-history">
    <div v-if="showFlg" style="left: 40%; top: 30%; position: absolute">
      <dv-loading>Loading...</dv-loading>
    </div>
    <dv-border-box-8 :reverse="true" :dur=10 class="device-history-all">
      <div class="device-history-key"> <!--position: absolute;z-index: 1999;left: 10px;text-align: right;font-size: 20px; top: 1%-->
        <el-tag>{{$t('telemetryType')}}</el-tag>
        <el-select @change="selectProduct($event)" filterable v-model="selectDefault" :disabled = "showFlg">
          <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in selectBoards"></el-option>
        </el-select>
        <el-tag>{{$t('aggregation')}}</el-tag>
        <el-select @change="selectPolymerization($event)" filterable v-model="polymerizationSelect" :disabled = "showFlg">
          <el-option :key="item.id" :label="item.name" :value="item.id" :disabled="item.disabled" v-for="item in polymerization"></el-option>
        </el-select>
      </div>
      <div  class="device-history-time"> <!--position: absolute; z-index: 1999;right: 10px;text-align: right;font-size: 20px;top:1%;-->
        <el-button @click="dayData" round :disabled = "showFlg">{{$t('day')}}</el-button>
        <el-button @click="weekData" round :disabled = "showFlg">{{$t('week')}}</el-button>
        <el-button @click="monthData" round :disabled = "showFlg">{{$t('month')}}</el-button>
        <el-date-picker @change="selectTime" :disabled = "showFlg" :end-placeholder="$t('endTime')" key="time" :range-separator="$t('to')" :start-placeholder="$t('startTime')"
                        type="datetimerange" v-model="value1"></el-date-picker>
        <el-button @click="exportData" round style=" float: right" :disabled = "showFlg">{{$t("export")}}</el-button>
      </div>
      <div class="device-history-left" >
        <p>{{$t("sum")}}：{{sum}}</p>
        <p>{{$t("avg")}}：{{avg}}</p>
      </div>
      <div class="device-history-middle">
        <p>{{$t('max')}}：{{max}}</p>
        <p>{{$t('min')}}：{{min}}</p>
      </div>
      <div class="device-history-right">
        <p>{{$t('timeInterval')}}：{{addNum}}</p>
        <p :style="evaporationDisplay()">{{$t("evaporation")}}：{{evaporationNum}}</p>
        <p :style="totalRadiationDisplay()">{{$t("sum")}}：{{totalRadiationNum}}</p>
        <p :style="cumFlowDisplay()">{{$t("cumFlow")}}：{{cumFlowSum}}</p>
      </div>
      <div class="device-history-chart" id="deviceChart"></div>
    </dv-border-box-8>
  </div>
</template>

<script>
  import moment from "moment";
  import {getTimeDeviceHistory} from "../untils/api/home";

  export default {
    name: 'DeviceHistory',
    props: ["partInfo"],
    data() {
      return {
        option: {}, //样式
        selectBoards: [],
        selectDefault: '',
        deviceId: {},
        telemetryKey: this.partInfo,
        dataArrList: [],//时间总数据
        valueArrList: [],//value 总数据
        exportList: [],
        totalRadiationList:[],
        name: '',//名称
        showFlg: false,
        polymerization: [
          {id: 1, name: this.$t('max'), disabled:false},
          {id: 2, name: this.$t('min'), disabled:false},
          {id: 3, name: this.$t('avg'), disabled:false},
          {id: 4, name: 'NONE', disabled:true},
        ],
        polymerizationSelect:1,
        value1: [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")],
        startTime: '',
        endTime: '',
        interval: 0,
        agg: '',
        unit: '',
        sum: 0,
        avg: 0,
        min: 0,
        max: 0,
        addNum: 0,
        evaporationNum:0,
        totalRadiationNum: 0,
        cumFlowSum:0,
        unit: '',
        cumulative: ''
      }
    },

    watch: {
      partInfo() {
        this.telemetryKey = this.partInfo;
        this.selectDefault = this.telemetryKey.en;
        this.dayData();
      }
    },

    methods: {
      getDeviceKeyList(deviceId, keyResponse) {
        this.setEmptyOption();
        this.selectBoards = [];
        this.selectDefault = '';
        this.deviceId = {};
        this.dataArrList = [];
        this.valueArrList = [];
        this.exportList = [];
        this.name = '';
        this.unit = '';
        this.startTime = '';
        this.endTime = '';
        this.value1 = [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")];
        this.max = 0;
        this.min = 0;
        this.avg = 0;
        this.sum = 0;
        this.addNum = 0;

        if(keyResponse.length == 0) {//key不存在
          return;
        }

        this.deviceId = deviceId;
        this.polymerizationSelect = 1;

        let pattern = /^[A-Za-z0-9.-_-]+$/;
        for(let i = 0; i < keyResponse.length; i++) {
          if (pattern.test(keyResponse[i]) && !keyResponse[i].includes('ipv64g') && !keyResponse[i].includes('sig4g') && !keyResponse[i].includes('sigwifi')) {
            let linkName = {};
            linkName.id = keyResponse[i];
            linkName.name = this.$t(keyResponse[i]).split(',')[0];
            this.selectBoards.push(linkName);
          }
        }

        this.selectDefault = this.selectBoards[0].id;
      },

      selectProduct(event) {
        console.log("选中的遥测key", event);
        this.selectDefault = event;
        this.getSelectHistoryValue();
      },

      dayData() {
        this.value1 = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm"), moment().format("YYYY-MM-DD HH:mm")];
        this.startTime = new Date(moment().subtract(1, "days")).getTime();
        this.endTime = new Date(moment()).getTime();
        this.selectPolymerization(this.polymerizationSelect);
      },

      weekData() {
        this.value1 = [moment().subtract(7, "days").format("YYYY-MM-DD HH:mm"), moment().format("YYYY-MM-DD HH:mm")];
        this.startTime = new Date(moment().subtract(7, "days")).getTime();
        this.endTime = new Date(moment()).getTime();
        this.selectPolymerization(this.polymerizationSelect);
      },

      monthData() {
        this.value1 = [moment().subtract(1, "months").format("YYYY-MM-DD HH:mm"), moment().format("YYYY-MM-DD HH:mm")];
        this.startTime = new Date(moment().subtract(1, "months")).getTime();
        this.endTime = new Date(moment()).getTime();
        this.selectPolymerization(this.polymerizationSelect);
      },

      selectTime(val) {
        //this.getSelectValue();  获取历史数据
        if(val === null) {
          this.value1 = [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")];
          this.startTime = '';
          this.endTime = '';
        } else {
          this.startTime = new Date(val[0]).getTime();
          this.endTime = new Date(val[1]).getTime();
        }

        this.selectPolymerization(this.polymerizationSelect);
      },

      selectPolymerization(event) {
        this.polymerizationSelect = event;
        let time = this.endTime - this.startTime;
        if(time <= 1000 * 60 * 60 * 24) {
          this.agg = 'NONE';
          this.interval = 0;
          this.polymerization[0].disabled = true;
          this.polymerization[1].disabled = true;
          this.polymerization[2].disabled = true;
          this.polymerization[3].disabled = false;
          this.polymerizationSelect = 4;
          this.getSelectHistoryValue();
        } else {
          this.polymerization[0].disabled = false;
          this.polymerization[1].disabled = false;
          this.polymerization[2].disabled = false;
          this.polymerization[3].disabled = true;
          if(this.polymerizationSelect == 4)  this.polymerizationSelect = 1;
          switch (this.polymerizationSelect) {
            case 1:
              this.agg = 'MAX';
              this.setInterval();
              this.getSelectHistoryValue();
              break;
            case 2:
              this.agg = 'MIN';
              this.setInterval();
              this.getSelectHistoryValue();
              break;
            case 3:
              this.agg = 'AVG';
              this.setInterval();
              this.getSelectHistoryValue();
              break;
          }
        }
      },

      setInterval() {
        let intervalTime = (this.endTime - this.startTime) / (1000 * 60 * 60 * 24);
        switch (true) {
          case intervalTime > 1 && intervalTime <= 3:
            this.interval = 1000 * 60 * 10;
            break;
          case intervalTime > 3 && intervalTime <= 5:
            this.interval = 1000 * 60 * 15;
            break;
          case intervalTime > 5 && intervalTime <= 10:
            this.interval = 1000 * 60 * 30;
            break;
          case intervalTime > 10 && intervalTime <= 20:
            this.interval = 1000 * 60 * 60;
            break;
          case intervalTime > 20 && intervalTime <= 30:
            this.interval = 1000 * 60 * 60 * 2;
            break;
          case intervalTime > 30 && intervalTime <= 90:
            this.interval = 1000 * 60 * 60 * 5;
            break;
          case intervalTime > 90 && intervalTime <= 180:
            this.interval = 1000 * 60 * 60 * 10;
            break;
          case intervalTime > 180 && intervalTime <= 240:
            this.interval = 1000 * 60 * 60 * 12;
            break;
          case intervalTime > 240:
            this.interval = 1000 * 60 * 60 * 24;
            break;
        }
      },

      getSelectHistoryValue() {
        this.dataArrList = [];
        this.valueArrList = [];
        this.exportList = [];
        this.totalRadiationList = [];
        let start = this.startTime === '' ? new Date(moment()).getTime() : this.startTime;
        let end = this.endTime === '' ? new Date(moment().subtract(-1, "days")).getTime() : this.endTime;
        if(this.selectDefault === 'TotalRadiation' || this.selectDefault === 'Radiation' || this.selectDefault === 'RadiationR' || this.selectDefault === 'RadiationV'
          || this.selectDefault === 'RadiationL' || this.selectDefault === 'Dradiation' || this.selectDefault === 'Sradiation' || this.selectDefault === 'Hradiation'
          || this.selectDefault === 'Radia' || this.selectDefault === 'TotalRadiation1' || this.selectDefault === 'TotalRadiation2' || this.selectDefault === 'Rad'
          || this.selectDefault === 'solarFlat' || this.selectDefault == 'solarAngle') {
          this.cumulative = this.$t("sunshine");
        } else {
          this.cumulative = this.$t("sum");
        }
        let param = '';
        if(this.selectDefault == 'HI') {
          param = 'ambientHumidity,ambientTemperature';
        } else if(this.selectDefault == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
          param = 'level';
          this.interval = 1000 * 60 * 60;
          this.agg = 'AVG';
          this.polymerizationSelect = 3;
        } else {
          param = this.selectDefault;
        }
        this.showFlg = true;
        getTimeDeviceHistory(this.deviceId.entityType, this.deviceId.id, param, start, end, this.interval, this.agg).then(response => {
          this.showFlg = false;
          if (JSON.stringify(response) == "{}") {
            this.setEmptyOption();
            this.max = 0;
            this.min = 0;
            this.avg = 0;
            this.sum = 0;
            this.addNum = 0;
          } else {
            if(this.selectDefault == 'HI') {
              let HIResponse = [];
              let humArray = response['ambientHumidity'];
              let temArray = response['ambientTemperature'];
              let min = Math.min(
                humArray.length,
                temArray.length
              );

              for(let i = 0; i < min; i++) {
                let HIJson = {};
                let HI = this.calculateHeatIndex(parseFloat(temArray[i].value), parseFloat(humArray[i].value));
                HIJson.ts = humArray[i].ts;
                HIJson.value = HI;
                HIResponse.push(HIJson)
              }

              this.name = '热量指数';
              this.unit = '';
              for(let i = 0; i < HIResponse.length; i++) {
                this.dataArrList.push(this.dateFormat(HIResponse[i].ts).substring(5));
                this.valueArrList.push(parseFloat(parseFloat(HIResponse[i].value).toFixed(3)));
                this.exportList.push({
                  ts: this.dateFormat(HIResponse[i].ts),
                  value: parseFloat(HIResponse[i].value).toFixed(3)
                });
              }

              //设置样式
              this.max = Math.max(...this.valueArrList).toFixed(2);
              this.min = Math.min(...this.valueArrList).toFixed(2);
              const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
              this.avg  = parseFloat(arrayAverage(this.valueArrList)).toFixed(2);
              this.setLightnum();
              this.setEmptyOption();
              this.setOption();
            } else if(this.selectDefault == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
              this.cumFlowSum = 0;
              let cumSum = 0;
              for (let obj in response) {
                this.name = this.$t(obj).split(',')[0];
                this.$t(obj).split(',')[1] === undefined ? this.unit = '' : this.unit = this.$t(obj).split(',')[1];
                for (let i = 0; i < response[obj].length; i++) {
                  let levelNum = 0;
                  if(parseFloat(response[obj][i].value) < 0) {
                    levelNum = 0;
                  } else {
                    levelNum = parseFloat(response[obj][i].value);
                  }
                  cumSum += parseFloat(levelNum.toFixed(4)) * 2399.5;
                  this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                  this.valueArrList.push(parseFloat(parseFloat(response[obj][i].value).toFixed(4)));
                  this.exportList.push({
                    ts: this.dateFormat(response[obj][i].ts),
                    value: parseFloat(response[obj][i].value).toFixed(4)
                  });
                }
              }
              this.cumFlowSum = cumSum.toFixed(4);
              this.max = Math.max(...this.valueArrList).toFixed(2);
              this.min = Math.min(...this.valueArrList).toFixed(2);
              const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
              this.avg  = parseFloat(arrayAverage(this.valueArrList)).toFixed(2);
              const getSum =  arr => arr.reduce(function(prev,curr,index,arr){return prev + curr;});
              this.sum  = parseFloat(getSum(this.valueArrList)).toFixed(2);
              this.setEmptyOption();
              this.setOption();
            } else {
              let levelRefer = localStorage.getItem('levelRefer');//获取设置的水位值
              let snowRefer = localStorage.getItem('snowRefer'); //获取设置雪深值
              let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声值
              let emptyHDRefer = localStorage.getItem('emptyHDRefer');//获取设置高程值
              for (let obj in response) {
                this.name = this.$t(obj).split(',')[0];
                this.$t(obj).split(',')[1] === undefined ? this.unit = '' : this.unit = this.$t(obj).split(',')[1];
                for (let i = 0; i < response[obj].length; i++) {
                  if(this.selectDefault == 'level' || this.selectDefault == 'Rwater' || this.selectDefault == 'waterlevel') {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(Math.abs(parseFloat(levelRefer) +  parseFloat(response[obj][i].value)).toFixed(4).toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: Math.abs(parseFloat(levelRefer) + parseFloat(response[obj][i].value)).toString()
                    });
                  } else if(this.selectDefault == 'snowHeight' || this.selectDefault == 'snowheight' ||  this.selectDefault == 'sHt') {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(Math.abs(parseFloat(snowRefer) +  parseFloat(response[obj][i].value)).toFixed().toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: Math.abs(parseFloat(snowRefer) + parseFloat(response[obj][i].value)).toString()
                    })
                  } else if(this.selectDefault == 'noise' || this.selectDefault == 'noi' || this.selectDefault == 'noise1' || this.selectDefault == 'noise2') {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(Math.abs(parseFloat(noiseRefer) +  parseFloat(response[obj][i].value)).toFixed(1).toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: Math.abs(parseFloat(noiseRefer) + parseFloat(response[obj][i].value)).toString()
                    })
                  } else if(this.selectDefault == 'emptyHD') {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(Math.abs(parseFloat(emptyHDRefer) +  parseFloat(response[obj][i].value)).toFixed(3).toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: Math.abs(parseFloat(emptyHDRefer) + parseFloat(response[obj][i].value)).toFixed(3)
                    })
                  } else {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(parseFloat(response[obj][i].value).toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: parseFloat(response[obj][i].value).toString()
                    });
                  }
                }
              }

              this.max = Math.max(...this.valueArrList).toFixed(2);
              this.min = Math.min(...this.valueArrList).toFixed(2);
              const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
              this.avg  = parseFloat(arrayAverage(this.valueArrList)).toFixed(2);
              this.setLightnum();
              this.getEvaporation();
              this.setEmptyOption();
              this.setOption();
            }
          }
        }).catch(error => {
          this.max = 0;
          this.min = 0;
          this.avg = 0;
          this.sum = 0;
          this.addNum = 0;
          this.showFlg = false;
          this.$message({
            showClose: true,
            type: "warning",
            message: "数据查询失败，请稍后再试"
          })
        })

      },

      getEvaporation() {
        this.evaporationNum = 0;
        if(this.selectDefault === 'Evaporation'){
          let num = 0;
          if(this.dayFlg){
            for(let i = 0; i < this.valueArrList.length -1; i++){
              if(this.valueArrList[i] - this.valueArrList[i + 1] <= 0){
                num += -(this.valueArrList[i] - this.valueArrList[i + 1]);
              }
            }
            this.evaporationNum = parseFloat(num.toFixed(2));
          } else {
            for(let i = 1; i < this.valueArrList.length; i++){
              if(this.valueArrList[i] - this.valueArrList[i - 1] <= 0){
                num += -(this.valueArrList[i] - this.valueArrList[i - 1]);
              }
            }
            this.evaporationNum = parseFloat(num.toFixed(2));
          }
        }
      },

      calculateHeatIndex(T, RH) {
        // 系数定义
        const c1 = -42.379;
        const c2 = 2.04901523;
        const c3 = 10.14333127;
        const c4 = -0.22475541;
        const c5 = -0.00683783;
        const c6 = -0.05481717;
        const c7 = 0.00122874;
        const c8 = 0.00085282;
        const c9 = -0.00000199;

        // 热量指数计算
        let HI = c1 + (c2 * T) + (c3 * RH) + (c4 * T * RH) + (c5 * T * T) + (c6 * RH * RH) +
          (c7 * T * T * RH) + (c8 * T * RH * RH) + (c9 * T * T * RH * RH);

        return HI;
      },

      /**
       * 设置累计值或者辐射日照实数
       */
      setLightnum() {
        //辐射日照时数
        if(this.selectDefault === 'TotalRadiation' || this.selectDefault === 'Radiation' || this.selectDefault === 'RadiationR' || this.selectDefault === 'RadiationV'
          || this.selectDefault === 'RadiationL' || this.selectDefault === 'Dradiation' || this.selectDefault === 'Sradiation' || this.selectDefault === 'Hradiation'
          || this.selectDefault === 'Radia' || this.selectDefault === 'TotalRadiation1' || this.selectDefault === 'TotalRadiation2' || this.selectDefault === 'Rad'
          || this.selectDefault === 'solarFlat' || this.selectDefault === 'solarAngle') {
          let timeStamp = 0;
          if(this.dayFlg){
            //一天内的总辐射值
            for(let i = 0; i < this.exportList.length -1; i++){
              if(this.exportList[i].value > 1.2) {
                timeStamp += new Date(this.exportList[i].ts).getTime() - new Date(this.exportList[i + 1].ts).getTime();
              }
            }
          } else {
            //聚合函数的总辐射
            for(let i = 1; i < this.exportList.length; i++){
              if(this.exportList[i].value > 1.2) {
                timeStamp += new Date(this.exportList[i].ts).getTime() - new Date(this.exportList[i - 1].ts).getTime();
              }
            }
          }
          this.addNum = 0;
          this.sum = parseFloat(timeStamp/(1000 * 60 * 60)).toFixed(2);
          //const getSum =  arr => arr.reduce(function(prev,curr,index,arr){return prev + curr;});
          //this.totalRadiationNum = parseFloat(getSum(this.valueArrList)).toFixed(2);
          this.getSumTotalRadiation();
        } else {
          let addSum = 0;
          //累计值
          const getSum =  arr => arr.reduce(function(prev,curr,index,arr){return prev + curr;});
          this.sum  = parseFloat(getSum(this.valueArrList)).toFixed(2);

          if(this.dayFlg){
            //一天内的时段值
            for(let i = 0; i < this.exportList.length -1; i++){
              addSum += this.exportList[i].value - this.exportList[i + 1].value;
            }
            this.addNum = parseFloat(addSum).toFixed(2);
          } else {
            //聚合函数的时段值
            for(let i = 1; i < this.exportList.length; i++){
              addSum+= this.exportList[i].value - this.exportList[i - 1].value;
            }
            this.addNum = parseFloat(addSum).toFixed(2);
          }
        }
      },

      evaporationDisplay(){
        if(this.selectDefault !== 'Evaporation'){
          return {
            display:'none'
          }
        }
      },


      getSumTotalRadiation() {
        if(this.endTime - this.startTime <= 1000 * 60 * 60 * 24) {
          this.totalRadiationList.sort(function (a, b) {
            return b.ts < a.ts ? 1 : -1
          });

          this.getTotalRadiationNum(60, this.totalRadiationList);
        } else {
          this.totalRadiationNum = 0;
          this.$message({
            showClose: true,
            type: "warning",
            message: "查看" + this.$t(this.selectDefault).split(",")[0] + "累计值，请选择24小时内的时间段"
          })
        }
      },


      getTotalRadiationNum(count, arr) {
        let index = 0;
        let arrTemp = [];
        let defaultTime = arr[0].ts;
        arrTemp.push([]);
        // 遍历原始数组
        for (let i = 0; i < arr.length; i++) {
          if(defaultTime + 1000 * 60 * 60 < arr[i].ts) {
            defaultTime = arr[i].ts;
            index++;
            arrTemp.push([]);
          }
          arrTemp[index].push(arr[i]);
        }

        let totalRadiation = 0;
        for(let i = 0; i < arrTemp.length; i++) {
          let totalSum = 0;
          for(let j = 0; j < arrTemp[i].length; j++) {
            totalSum += parseFloat(arrTemp[i][j].value) / 60;
          }
          totalRadiation += totalSum;
        }
        this.totalRadiationNum = parseFloat(totalRadiation).toFixed(2);
      },


      totalRadiationDisplay() {
        //TotalRadiation
        if(this.selectDefault == 'TotalRadiation' || this.selectDefault == 'Radiation' || this.selectDefault == 'RadiationR' || this.selectDefault == 'RadiationV'
          || this.selectDefault === 'RadiationL' || this.selectDefault === 'Dradiation' || this.selectDefault === 'Sradiation' || this.selectDefault === 'Hradiation'
          || this.selectDefault === 'Radia' || this.selectDefault === 'TotalRadiation1' || this.selectDefault === 'TotalRadiation2' || this.selectDefault === 'Rad'
          || this.selectDefault === 'solarFlat' || this.selectDefault === 'solarAngle'){
          return {
            display:'inline'
          }
        } else {
          return {
            display:'none'
          }
        }
      },

      cumFlowDisplay() {
        if(this.selectDefault == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
          return {
            display:'inline'
          }
        } else {
          return {
            display:'none'
          }
        }
      },

      setOption() {
        let that = this;
        this.option = {
          color: ['#FEC00A',],
          title: {
            text: this.name,
            left: 'center', //居中
            top:'45',
            textStyle: {
              color: '#ffffff',
              fontSize: 20,
              lineHeight: 35,
              fontWeight: 'normal'
            }
          },
          tooltip: { //提示框
            trigger: 'axis',
            backgroundColor: "rgba(128, 128, 128, 0.5)",
            borderWidth: 1, //边框宽度设置1
            borderColor: "rgba(49, 73, 99, 1)", //设置边框颜色
            borderRadius: 4,
            padding: 5,
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function(params) {
              if(that.name == '天气状况') {
                let time = params[0].axisValue; // 获取时间
                let value = '';
                switch (parseInt(params[0].data)) {
                  case 0:
                    value = "晴";
                    break;
                  case 16:
                    value = "大雨";
                    break;
                  case 17:
                    value = "中雨";
                    break;
                  case 18:
                    value = "小雨";
                    break;
                  case 32:
                    value = "大毛毛雨";
                    break;
                  case 33:
                    value = "中毛毛雨";
                    break;
                  case 34:
                    value = "小毛毛雨";
                    break;
                  case 50:
                    value = "大雪";
                    break;
                  case 51:
                    value = "中雪";
                    break;
                  case 52:
                    value = "小雪";
                    break;
                  case 64:
                    value = "烟";
                    break;
                  case 80:
                    value = "雾";
                    break;
                  case 96:
                    value = "冰雪或高空坠物";
                    break;
                  case 153:
                    value = "飞虫或异常遮挡";
                    break;
                }

                return that.$t('time') + '：' + time + '<br>' + that.$t('Weather') + '：' + value;
              } else {
                let time = params[0].axisValue; // 获取时间
                let value = params[0].data; // 获取数值

                return that.$t('time') + '：' + time + '<br>' + that.$t('value') + '：' + value;
              }
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '3%',
            top:'35%',
            containLabel: true //grid区域是否包含坐标轴的刻度标签
          },
          xAxis: {
            name: this.$t("time"),
            type: 'category', //坐标轴类型。
            boundaryGap: true, //坐标轴两边留白策略
            data: this.dataArrList,
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize :14//字体大小
              },
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                // color:'#3a4650'// rgb(2,121,253)
                color: 'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick: {
              show: false
            },
            nameTextStyle: {
              color: '#ffffff',
              fontSize: 14
            }
          },
          yAxis: {
            name: this.$t("value") + ' (' + this.unit + ')',
            type: 'value',
            nameTextStyle:{
              color:'#fff',
              fontSize :14//字体大小
            },
            show: true, //隐藏坐标
            axisLabel: { //y轴的坐标文字
              show: true, //不显示坐标控件
              textStyle: {
                color: '#fff', //文字的颜色
                fontSize :14//字体大小
              },
            },
            // max:this.max,//最大值
            // min:this.min,
            splitLine:{  //坐标在grid区域的分割线
              show: false,// 不显示网格
              lineStyle: { //设置分割线的样式(图表横线颜色)
                color: ['#153a8a'] //网格颜色
              }
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'//#3a4650  rgb(2,121,253) #3a4650
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            },
          },
          series: [
            {
              type: 'line',
              data: this.valueArrList,
              symbolSize: 5,
              smooth: true,
              animationDuration: 1000,
              lineStyle:{
                color:'#FEC00A'
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
          ],
          dataZoom: [
            {
              endValue: 15, //一次显示10个
              type: 'slider',//有滑动条
              show: false,//是否显示滑动条
              xAxisIndex: [0],//开始下标
              handleSize: 0,//滑动条的左右2个滑动条大小
              height: 20, //滑动条高度
              left: "0%",//左边距离
              right: "0%",//右边距离
              bottom: 0,//底部距离
              // borderColor: "#3a4650", //边框颜色
              borderColor: "#101f3e", //边框颜色
              fillerColor: "#4C7C98",//选中区域的背景色#345A7C#4878fe
              borderRadius: 5,//边框弧度
              //backgroundColor: "#1c2735",//未选区域中的背景色
              backgroundColor:'#0b2d4c',
              showDataShadow: false, //是否显示数据阴影
              showDetail:false,//拖动时是否显示数值
              realtime: true,// 是否实时更新
              filterMode: "filter",
            },
            {
              //左右滑动
              type: "inside",
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100,
            }
          ]

        }
        this.meteCharts();//加载折线图
      },


      setEmptyOption() {
        this.option = {};
        this.meteCharts();//加载折线图
      },

      meteCharts(){
        document.getElementById("deviceChart").removeAttribute("_echarts_instance_");
        let chartOption = this.$echarts.init(document.getElementById('deviceChart'));
        chartOption.setOption(this.option);
        //图表自适应
        window.addEventListener("resize",function(){
          chartOption.resize()  // myChart 是实例对象
        })
      },

      exportData() {
        let that = this;
        if (that.exportList.length === 0) {
          // alert("该时间区间内没有数据，请重新选择");
          that.$message({
            showClose: true,
            type: "warning",
            message: that.$t("dataError")
          });
          return;
        }

        // 克隆原始 exportList，避免污染原数组
        const dataList  = that.exportList.slice();
        const unit = that.unit || '';
        const addUnit = val => unit ? `${val}${unit}` : val;
        // 构造统计项并放在最前面
        const statsList = [
          { ts: that.$t("max"), value: addUnit(parseFloat(that.max)) },
          { ts: that.$t("min"), value: addUnit(parseFloat(that.min)) },
          { ts: that.$t("avg"), value: addUnit(parseFloat(that.avg)) }
        ];

        // 给数据区也添加单位
        const mainList = dataList.map(item => ({
          ts: item.ts,
          value: addUnit(item.value)
        }));


        // 合并统计项 + 正常数据项
        const finalList = statsList.concat(mainList);

        const {export_json_to_excel} = require('../vendor/Export2Excel');
        const tHeader = [this.$t("time"), this.$t("value"),];
        const filterVal = ['ts', 'value',];
        const data = that.formatJson(filterVal, finalList);
        export_json_to_excel(tHeader, data, this.name + " " +  this.$t("dataList"));

        // let that = this;
        // if (that.exportList.length === 0) {
        //   that.$message({
        //     showClose: true,
        //     type: "warning",
        //     message: that.$t("dataError")
        //   });
        //   return;
        // }
        //
        // const exportList = that.exportList.slice();
        //
        // const maxValue = parseFloat(that.max);
        // const minValue = parseFloat(that.min);
        // const avgValue = parseFloat(that.avg);
        //
        // // 将最大、最小、平均值填入第一行
        // const list = exportList.map((item, index) => {
        //   return {
        //     ts: item.ts,
        //     value: item.value,
        //     max: index === 0 ? maxValue : '',  // 仅第一行显示
        //     min: index === 0 ? minValue : '',
        //     avg: index === 0 ? avgValue : ''
        //   };
        // });
        //
        // const tHeader = [
        //   this.$t("time"),
        //   this.$t("value"),
        //   this.$t("max"),
        //   this.$t("min"),
        //   this.$t("avg"),
        // ];
        //
        // const filterVal = ['ts', 'value', 'max', 'min', 'avg'];
        //
        // const data = this.formatJson(filterVal, list);
        //
        // const { export_json_to_excel } = require('../vendor/Export2Excel');
        // export_json_to_excel(tHeader, data, this.name + " " + this.$t("dataList"));

      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },

      dateFormat(timestamp) {
        if (timestamp && timestamp != "") {
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      }
    }
  }
</script>

<style scoped lang="less">
  @import "less/DeviceHistory.less";
</style>



// WEBPACK FOOTER //
// src/components/DeviceHistory.vue